/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { VNode } from 'vue';
import { namespace } from 'vuex-class';
import { Component, InjectReactive, Mixins } from 'vue-property-decorator';

import AboutPanel from '@/components/about-panel';
import HomeBottomBar from '@/components/home-bottom-bar';
import FinanceBusiness from '@/mixins/finance-business';
import isPrerendering from '@/shared/utils/isPrerendering';
import { creditTaskStatusTypeEnum } from '@/enums/autarkyUpgrade';
import platform from '@/shared/utils/platform';
import MessageNoticeBar from '@/pages/home/components/MessageNoticeBar/index.vue';
import PocketMoneyCard from '@/pages/home/components/PocketMoneyCard/index.vue';
import store from '@/store';
import { isCreditTaskOcrSuspend } from '@/pages/home/utils';
import FinanceCreditCard from '../../components/finance-credit-card';
import type { Home } from '../../types';
import FutureList from '../../components/advantage-list';
import RiskStatement from '../../components/risk-statement';

const HomeStore = namespace('home');

// 天下信用banner
const TxxyBanner = () => import(
  /* webpackChunkName: "txxy-banner" */'../../components/adv-txxy-banner/index.vue'
) as any;

const _isPrerendering = isPrerendering();
const style: Dictionary = require('./index.module.scss');

@Component
export default class TaglessContent extends Mixins(FinanceBusiness) {
  @InjectReactive() homePage?: Home;

  @HomeStore.State canSlidInQuality!: boolean;

  @HomeStore.State marketSource!: string;

  @HomeStore.State userId!: string;

  @HomeStore.Action $updateState!: (data: Dictionary) => void;

  private show = false;

  private flag = false;

  private startY = 0

  private endY = 0

  private startX = 0

  private endX = 0


  // 开始
  private onTouchstart(event: Event) {
    this.startX = (event as any).touches[0].pageX;
    this.startY = (event as any).touches[0].pageY;
  }

  // 上滑
  private onTouchMove() {
    this.flag = !!this.canSlidInQuality;
  }

  // 手指离开
  private onTouchend(event: Event) {
    this.endX = (event as any).changedTouches[0].pageX;
    this.endY = (event as any).changedTouches[0].pageY;

    if (this.flag) {
      const result = this.getSlideDirection(this.startX, this.startY, this.endX, this.endY);

      if (result) {
        this.$emit('touchEnd');
      }
    }
  }

  private getSlideDirection(startX: number, startY: number, pageX: number, pageY: number) {
    const dx = pageX - startX;
    const dy = pageY - startY;
    if (Math.abs(dx) > Math.abs(dy) && dx > 0) {
      return false;
    } if (Math.abs(dx) > Math.abs(dy) && dx < 0) {
      return false;
    } if (Math.abs(dy) > Math.abs(dx) && dy > 0) {
      return false;
    } if (Math.abs(dy) > Math.abs(dx) && dy < 0) {
      this.show = true;
      return true;
    }
    return false;
  }

  /** 申请额度、审批中，跳转逻辑 */
  private onCreditAmount(event: Event) {
    event.stopPropagation();

    const {
      creditStatus,
      preCredit,
      preCreditUserSource,
      normalPreCreditModel,
    } = this.creditData || {};
    const userInfo = this.businessInfoExtra?.userInfo || {};

    const ubtCommonParams = {
      preCreditUserSource,
      normalPreCreditModel,
      creditStatus: String(creditStatus),
      preCredit: String(preCredit),
      couponType: this.creditData?.freeCouponType || '',
      // 包含定价标签（pricingTag）、风险标签（risk24UserSource）等用户信息
      ...userInfo,
    };

    if (this.creditData) {
      if (preCredit) {
        this.onPreCreditApplyProduct('finance_tagless_draw', ubtCommonParams);
      } else {
        this.$ubtPageButtonNew('finance_tagless_creditAmount', ubtCommonParams);
        this.onApplyCredit();
      }
    }
  }

  /** 极简流程-按钮文案
   * 按钮展示逻辑梳理详见：https://hellobike.yuque.com/yxr77w/oyyz8n/krutof7a6z8r8h9m
   */
  private renderSimpleButtonText() {
    const {
      progressingTaskId,
      creditTaskStatus,
      preCredit,
    } = this.creditData || {};

    let buttonName: string | VNode = '';

    /** 有 进行中授信任务 id */
    if (progressingTaskId) {
      /** 有进行中授信任务 id，且任务挂起状态（自营 B 失败，联营未补充资料） */
      if (creditTaskStatus === creditTaskStatusTypeEnum.HANG) {
        buttonName = isCreditTaskOcrSuspend(this.creditData)
          ? '补充身份证，提交额度申请'
          : '去补充资料';
      } else {
        buttonName = '额度审批中，请耐心等待';
      }
    } else {
      if (preCredit) {
        buttonName = '去提现';
      } else {
        if (this.canReceiveAmount) {
          buttonName = '申请额度';
        } else {
          buttonName = '只差一步，继续申请';
        }
      }
    }
    return this.creditData ? buttonName : '';
  }

  private render() {
    return (
      <div class={[
        style.TagHome,
      ]}>
        <div class={style.taglessNewUserHome}>
          <div class={[
            style.contentBottom,
            this.show && style.transLate,
            !_isPrerendering && this.canSlidInQuality && style.withArrow,
          ]}
          ontouchstart={this.onTouchstart.bind(this)}
          ontouchmove={this.onTouchMove.bind(this)}
          ontouchend={this.onTouchend.bind(this)}>
            {this.creditData && (
              <MessageNoticeBar
                userCreditData={this.creditData}
                className={'homeMessageNoticeBarWrapper'}
              />
            )}
            <FinanceCreditCard
              buttonName={this.renderSimpleButtonText()}
              isAnimateBtn={this.canReceiveAmount}// 申请额度按钮加上动效
              onEmitClick={this.onCreditAmount.bind(this)}/>
            {this.creditData && (
              <PocketMoneyCard
                userCreditData={this.creditData}
              />
            )}
            {/** 天下信用banner, 由广告平台圈选展示规则 */}
            {!platform.isWechatMini && <TxxyBanner/>}
            <FutureList />
            {!_isPrerendering && (
              <div class={style.aboutWrapper}>
                 <AboutPanel currentHomePage={'taglessHome'} />
              </div>
            )}
          </div>
          </div>
          <RiskStatement />
        {// 挂载身份证清晰分不够弹窗 dom
          this.getUpdatedIdentityPhotoDialog()
        }
        {!_isPrerendering && (
          <HomeBottomBar />
        )}
      </div>
    );
  }
}
